import React from 'react'
import Home from './Home'
import Header from './Header'
import './App.scss';

function App() {
  
  return (
    <div className="app">
      <Header/>
<Home/>

    </div>
  )
}

export default App